import { makeStyles } from "@material-ui/core/styles";


export const drawerWidth = 375;
export const useStyles = makeStyles({
    drawer: {
        width: drawerWidth,
    },
    [`@media (max-width: ${2 * drawerWidth}px)`]: {
        drawer: {
            width: "60vw",
        },
    },
    drawerComponents: {
        display: "flex",
        flexDirection: "column",
        padding: "0 1.5em 0 1.5em",
        rowGap: "1.5em",
    },
});
